import fetchTablaApi from "@helper/fetchTablaApi";
import { ProcessedArticleData } from "@transformer/useOsResponse";
import { MoreArticlesRequestData } from "@typings/MoreArticlesApi";

// ---------------------------- API Calls ------------------------------

export async function getMoreFeeds(
  requestData: MoreArticlesRequestData,
  loadOlderArticles?: boolean,
): Promise<ProcessedArticleData[]> {
  const queryParams = new URLSearchParams({
    sort: Array.isArray(requestData.sort) ? requestData.sort.join(",") : "",
    more: loadOlderArticles ? "older" : "today",
  }).toString();
  return await fetchTablaApi<ProcessedArticleData[]>(
    `get-quicknews-articles?${queryParams}`,
    "GET",
  );
}
